import React, { useState } from "react";
import Modal from 'react-modal';
import Header from '../components/header';
import { MealForm } from "../components/MealForm";
import '../components/scancss.css';
import Scanner from '../components/scanner';
import Fetch from "../components/SearchJAN";
import "../home.scss";
import "../index.scss";

export const CameraState = React.createContext(2);

export const ScanPage = () => {
  const [camera, setCamera] = useState(false);
  const [result, setResult] = useState<String>("");
  console.log(result)

  type propsType = {
    result : String
  }
  const onDetected = (result: String) => {
    //alert(result)
    setResult(result);
  };
  const [modal, setModal] = useState(false);
  const [cordRead, setcordRead] = useState(false);

  const openModal = () => {
    setCamera(false);
    setModal(true);
  };
  const closeModal = () => {
    setModal(false);
  };
  const ScanSystem = () => {
    openModal()
    setcordRead(true)
  };
  const WriteSystem = () => {
    openModal()
    setcordRead(false)
  };

  const ChangeModal = (props:propsType) => {
    //alert(props.result)
    if(cordRead){
      return(
        <Fetch code = {props.result}/>
        )
    }else{
      return(
        <MealForm/>
        )
    }
  }

  return (
    <div className="ScanPage">
      <Header />
      <br></br>
      <p style={{ textAlign: "center" }}>{result ? result : "バーコードを写してください。"}</p>
      <br></br>
      <div className=".text-center ">
        <button className="w-1/4 shadow-lg bg-cyan-500 shadow-cyan-500/50 text-white rounded px-2 py-1 mr-4 ml-5"
          onClick={() => setCamera(!camera)}>
          {camera ? "スキャン停止" : "スキャン開始"}
        </button>
        {result && <button className="w-1/4 shadow-lg bg-cyan-500 shadow-cyan-500/50 text-white rounded px-2 py-1 mr-6 ml-2"
        onClick={ScanSystem}>コードで登録する</button>}
        <button className="w-1/4 shadow-lg bg-cyan-500 shadow-cyan-500/50 text-white rounded px-2 py-1 mr-5"
        onClick={WriteSystem}>手入力で登録する</button>

      </div>
      <br></br>
      <Modal isOpen={modal}>
        <button onClick={closeModal}>取りやめる</button>
        <br></br>
        <p style={{textAlign:"center"}}>
        <ChangeModal result={result} ></ChangeModal>
        </p>
      </Modal>
      <br></br>
      <div className="container">
        {camera && <Scanner onDetected={onDetected} />}
      </div>
    </div>
  );
}

// const rootElement = document.getElementById("root");
// ReactDOM.render(<ScanPage />, rootElement);

// export default ScanPage;